/**
 * formatPhone
 * Recibe cualquier string de teléfono y devuelve el formato 8821-4189.
 * Si ya tiene el guión en la posición correcta, no hace nada.
 * Si no es un número CR de 8 dígitos, devuelve el valor sin cambios.
 */
export function formatPhone(value) {
  if (!value) return value;
  const digits = value.replace(/\D/g, "");
  // Solo aplica el formato a números de exactamente 8 dígitos
  if (digits.length === 8) {
    return `${digits.slice(0, 4)}-${digits.slice(4)}`;
  }
  return value;
}
